/**
 * AppShell — coquille des routes authentifiees.
 *
 * Compose <Sidebar> en colonne gauche + <Outlet> en colonne droite. Tient
 * la fenetre 100vh sans scroll global ; le scroll se fait dans la zone
 * principale.
 *
 * Utilisation : `<Route element={<AppShell />}>` avec les routes enfants
 * en <Outlet>. Voir App.tsx.
 */
import { Outlet } from 'react-router'

import { BulkUploadStackProvider } from '@/contexts/BulkUploadStackContext'
import { DrawerStackProvider } from '@/contexts/DrawerStackContext'

import Sidebar from './Sidebar'
import './AppShell.css'

export default function AppShell() {
  return (
    <DrawerStackProvider>
      <BulkUploadStackProvider>
        <div className="app-shell">
          <Sidebar />
          <main className="app-shell-content">
            <Outlet />
          </main>
        </div>
      </BulkUploadStackProvider>
    </DrawerStackProvider>
  )
}
